import { Box, Stack, SvgIcon, Typography } from "@mui/joy";
import CustomCard from "components/common/CustomCard";
import { useRecoilState, useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import { conceptNoteAtom } from "recoil/conceptNoteAtom";
import { taskListAtom } from "recoil/taskListAtom";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { CONCEPT_DOMAIN, CONCEPT_NOTE_DETAIL_ENDPOINT } from "api/conceptApi";
import { patientAtom } from "recoil/patientAtom";

export default function ConcernAndGoal() {
  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });
  const conceptNoteState = useRecoilValue(conceptNoteAtom);
  const taskListState = useRecoilValue(taskListAtom);
  const is1_2_A_done = taskListState.find(
    (element) => element.taskId === "1-2-A"
  )?.lastDoneAt;

  const queryClient = useQueryClient();
  const patientState = useRecoilValue(patientAtom);

  useEffect(() => {
    queryClient.invalidateQueries([
      CONCEPT_DOMAIN,
      CONCEPT_NOTE_DETAIL_ENDPOINT,
      patientState?.patientId,
    ]);
  }, [patientState?.patientId]);

  const data = [
    {
      label: t_ui("고민"),
      text: is1_2_A_done ? conceptNoteState?.concern : null,
      placeholder: t_ui("요즈음 나를 괴롭히는 고민은?"),
    },
    {
      label: t_ui("목표"),
      text: is1_2_A_done ? conceptNoteState?.goal : null,
      placeholder: t_ui("내가 만들고 싶은 변화는?"),
    },
  ];

  return (
    <CustomCard sx={{ py: "16px", px: "20px" }}>
      {data.map(({ label, text, placeholder }, index) => (
        <Box>
          <Typography color="primary">{label}</Typography>
          <Typography>{text || placeholder}</Typography>
          {index < data.length - 1 && (
            <Box
              sx={{
                my: "12px",
                height: "1px",
                width: "100%",
                backgroundColor: "background.level2",
              }}
            />
          )}
        </Box>
      ))}
    </CustomCard>
  );
}
